<template>
  <v-col cols="auto" class="pa-0">
    <v-badge
      overlap
      :content="count"
      :value="count && count != 0"
      color="error"
      bordered
      :offset-y="15"
      :offset-x="15"
      style="z-index: 3"
    >
      <base-button
        type="alternative"
        icon="mdi-speedometer"
        :tooltip="$i18n.t('sidebar.unassignedWatermeters.buttonTooltip')"
        @click="open"
      />
    </v-badge>
  </v-col>
</template>
<script>
import { call, get } from 'vuex-pathify';
export default {
  name: 'UnassignedWatermetersButton',
  computed: {
    projectId: get('layers/projectId'),
    count: get('billings/unassignedWatermetersCount'),
    layerId: get(
      'admin/modulesMapping@unassigned_watermeters.unassigned_watermeters_partitions_datasource.settings.layer_id'
    ),
  },
  methods: {
    getUnassignedWatermetersCount: call('billings/getUnassignedWatermetersCount'),
    async init() {
      await this.getUnassignedWatermetersCount();
    },
    open() {
      if (this.$route.name === 'unassignedWatermeters') return;
      this.$router.push({
        name: 'unassignedWatermeters',
        params: { lid: this.layerId },
        query: { project: this.projectId },
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-badge {
  z-index: 3 !important;
}
</style>
